import React, { Component } from 'react';
import { Modal, List, Input, Tabs } from 'antd';
import { Indicators } from './indicators';
const TabPane = Tabs.TabPane;

export class IndicatorSelector extends Component {
    constructor(props) {
        super(props);

        this.state = { q: '' };
    }

    render() {
        return (
            <Modal
                bodyStyle={{ height: 700, overflow: 'hidden', overflowY: 'scroll' }}
                title={`Select an Indicator (${Object.keys(Indicators).length} available)`}
                visible={this.props.open}
                onCancel={this.props.onClose.bind(this)}
                footer={null}
            >
                <Input.Search
                    autoFocus
                    style={{ marginBottom: 15 }}
                    value={this.state.q}
                    onChange={e => this.setState({ q: e.target.value })}
                />

                <Tabs defaultActiveKey="1">
                    <TabPane tab="Indicators" key="1">
                        <List
                            size="small"
                            bordered
                            dataSource={Object.keys(Indicators)
                                .map(indicator_id => {
                                    return { indicator_id, ...Indicators[indicator_id] };
                                })
                                .filter(indicator => {
                                    if (this.state.q.length === 0) return true;

                                    const match =
                                        indicator.indicator_id
                                            .toLowerCase()
                                            .indexOf(this.state.q.toLowerCase()) !== -1;

                                    if (match) return true;
                                    return (
                                        indicator.name
                                            .toLowerCase()
                                            .indexOf(this.state.q.toLowerCase()) !== -1
                                    );
                                })
                                .filter(a => !a.isCandlePattern)
                                .sort(function(a, b) {
                                    if (a.name < b.name) {
                                        return -1;
                                    }
                                    if (a.name > b.name) {
                                        return 1;
                                    }
                                    return 0;
                                })}
                            renderItem={item => (
                                <List.Item
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        this.props.onSelect(item);
                                        this.props.onClose();
                                    }}
                                >
                                    <List.Item.Meta title={item.name} />
                                    {item.group}
                                </List.Item>
                            )}
                        />
                    </TabPane>
                    <TabPane tab="Candle Patterns" key="2">
                        <List
                            size="small"
                            bordered
                            dataSource={Object.keys(Indicators)
                                .map(indicator_id => {
                                    return { indicator_id, ...Indicators[indicator_id] };
                                })
                                .filter(indicator => {
                                    if (this.state.q.length === 0) return true;

                                    const match =
                                        indicator.indicator_id
                                            .toLowerCase()
                                            .indexOf(this.state.q.toLowerCase()) !== -1;

                                    if (match) return true;
                                    return (
                                        indicator.name
                                            .toLowerCase()
                                            .indexOf(this.state.q.toLowerCase()) !== -1
                                    );
                                })
                                .filter(a => a.isCandlePattern)
                                .sort(function(a, b) {
                                    if (a.name < b.name) {
                                        return -1;
                                    }
                                    if (a.name > b.name) {
                                        return 1;
                                    }
                                    return 0;
                                })}
                            renderItem={item => (
                                <List.Item
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        this.props.onSelect(item);
                                        this.props.onClose();
                                    }}
                                >
                                    <List.Item.Meta title={item.name} />
                                    {item.group}
                                </List.Item>
                            )}
                        />
                    </TabPane>
                    <TabPane tab="Apex Indicators" key="3">
                        <List
                            size="small"
                            bordered
                            dataSource={Object.keys(Indicators)
                                .map(indicator_id => {
                                    return { indicator_id, ...Indicators[indicator_id] };
                                })
                                .filter(indicator => {
                                    if (this.state.q.length === 0) return true;

                                    const match =
                                        indicator.indicator_id
                                            .toLowerCase()
                                            .indexOf(this.state.q.toLowerCase()) !== -1;

                                    if (match) return true;
                                    return (
                                        indicator.name
                                            .toLowerCase()
                                            .indexOf(this.state.q.toLowerCase()) !== -1
                                    );
                                })
                                .filter(a => a.isApexCustom)
                                .sort(function(a, b) {
                                    if (a.name < b.name) {
                                        return -1;
                                    }
                                    if (a.name > b.name) {
                                        return 1;
                                    }
                                    return 0;
                                })}
                            renderItem={item => (
                                <List.Item
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        this.props.onSelect(item);
                                        this.props.onClose();
                                    }}
                                >
                                    <List.Item.Meta title={item.name} />
                                    {item.group}
                                </List.Item>
                            )}
                        />
                    </TabPane>
                </Tabs>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Shared/IndicatorManager/IndicatorSelector.js